/**
 * Mobile interaction utilities for enhanced UX
 */

export const hapticFeedback = {
  light: () => {
    if ("vibrate" in navigator) {
      navigator.vibrate(10);
    }
  },
  medium: () => {
    if ("vibrate" in navigator) {
      navigator.vibrate(20);
    }
  },
  heavy: () => {
    if ("vibrate" in navigator) {
      navigator.vibrate([30, 10, 30]);
    }
  },
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export const addTouchFeedback = (element: HTMLElement) => {
  if (!isTouchDevice()) return;

  element.addEventListener(
    "touchstart",
    () => {
      element.style.transform = "scale(0.98)";
      hapticFeedback.light();
    },
    { passive: true },
  );

  element.addEventListener(
    "touchend",
    () => {
      element.style.transform = "scale(1)";
    },
    { passive: true },
  );

  element.addEventListener(
    "touchcancel",
    () => {
      element.style.transform = "scale(1)";
    },
    { passive: true },
  );
};
